import React from 'react';
import { Link } from 'react-router-dom';

import useStyles from './styles';

type LinkProps =
    | {
          to: string;
          href?: never;
      }
    | {
          to?: never;
          href: string;
      };

type BaseProps = {
    icon: React.ReactNode;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    className?: string;
};

type Props = BaseProps & LinkProps;

const SubMenuItem: React.FC<Props> = ({ icon, title, href, to, subtitle, className }) => {
    const { classes, cx } = useStyles();
    const Component: React.ElementType = href ? 'a' : Link;
    const props = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : { to };

    return (
        <Component {...props} className={cx(classes.root, className)}>
            <span className={classes.icon}>{icon}</span>
            <div className={classes.text}>
                <span className={classes.title}>{title}</span>
                {subtitle ? <span className={classes.subtitle}>{subtitle}</span> : null}
            </div>
        </Component>
    );
};

export default SubMenuItem;
